{
  "links": {
    "access_context": "Contexto del acceso",
    "support": "Soporte"
  },
  "firmware": {
    "navigation_title": "Firmware"
  },
  "navigation_items": {
    "home": "Inicio",
    "dashboards": "Tableros",
    "devices": "Dispositivos",
    "alerts": "Alertas",
    "map": "Mapa",
    "certificates": "Certificados",
    "reports": "Informes",
    "analytics": "Noesis",
    "users": "Usuarios",
    "user_invitations": "Invitaciones de usuario",
    "organizations": "Organizaciones",
    "partnerships": "Asociaciones",
    "api_api": "Claves de API",
    "webhooks": "Webhooks",
    "archives": "Archivos",
    "calibrations": "Calibraciones",
    "firmwares": "Firmwares",
    "access_context": "Contexto del acceso"
  },
  "subheaders": {
    "monitoring": "Monitoreo",
    "analytics": "Analítica",
    "management": "Gestión",
    "general": "General",
    "admin": "Administración"
  }
}